import React, { Component, Fragment, createRef } from 'react';
import Button from './Button.js';
import styles from './Slider.module.scss';

const THRESHOLD_X = 50;
const THRESHOLD_Y = 100;

class Slider extends Component {
  constructor(props) {
    super(props);
    this.timer = null;

    this.state = {
      currentSlide: 0,
      parentWidth: 0
    };

    this.sliderParentRef = createRef();

    this.changeSlide = this.changeSlide.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  changeSlide(type) {
    const {currentSlide} = this.state;
    this.destroyTimer();
    if (type === 'left') {
      this.setState({
        currentSlide: currentSlide ? currentSlide - 1 : this.props.length - 1
      });
    } else {
      this.setState({
        currentSlide: (currentSlide + 1) % this.props.length
      });
    }
    this.initTimer();
  }

  initTimer() {
    if (!this.props.autoSlide) return;
    this.timer = setInterval(
      () => this.changeSlide('right'),
      this.props.sliderInterval
    );
  }

  destroyTimer() {
    if (!this.props.autoSlide) return;
    clearInterval(this.timer);
  }

  componentDidMount() {
    this.initTimer();
    this.setState({
      parentWidth: this.sliderParentRef.current.offsetWidth
    });
  }

  componentWillUnmount() {
    this.destroyTimer();
  }

  handleTouchStart(e) {
    this.startX = e.touches[0].clientX;
    this.startY = e.touches[0].clientY;
  }

  handleTouchEnd(e) {
    this.endX = e.changedTouches[0].clientX;
    this.endY = e.changedTouches[0].clientY;
    const diffX = this.endX - this.startX;
    const diffY = this.endY - this.startY;

    if (Math.abs(diffY) > THRESHOLD_Y || Math.abs(diffX) < THRESHOLD_X) return;
    this.changeSlide(diffX < 0 ? 'right' : 'left');
  }
  
  render() {
    const showLeft = !(this.state.currentSlide === 0);
    const showRight = !(this.state.currentSlide === this.props.length - 1);

    return (
      <Fragment>
        <div className={styles.sliderParent} ref={this.sliderParentRef}>
          <div
            className={styles.sliderContainer}
            style={{
              transform: `translateX(-${this.state.currentSlide * this.state.parentWidth}px)`
            }}
          >
            {this.props.children.map(element => {
              return React.cloneElement(
                element,
                {
                  handleTouchEnd: this.handleTouchEnd,
                  handleTouchStart: this.handleTouchStart
                },
              );
            })}
          </div>
        </div>
        {showLeft && <Button type='left' handleClick={this.changeSlide}/>}
        {showRight && <Button type='right' handleClick={this.changeSlide}/>}
      </Fragment>
    );
  }
}

Slider.defaultProps = {
  autoSlide: false,
  sliderInterval: 5 * 1000, // 1 second = 1000 ms
};

export default Slider;